.search-result {
    display: block;
    cursor: pointer;
    padding-left: 4px;
    background-color: #fff;
}

.search-result:hover {
    background-color: var(--list-hovered);
}

.search-result--fake-focus {
    composes: search-result;
    background-color: var(--list-hovered);
}

.results {
    height: calc(100% - 28px);
    box-sizing: border-box;
    overflow-y: auto;
    position: relative;
}

.result-header {
    font-size: 17px;
    margin: 0 16px;
    padding-bottom: 8px;
}

.result-entity-header {
    display: flex;
    justify-content: space-between;
    color: var(--grey-dk);
    font-size: 15px;
    margin: 16px 16px 8px 16px;
    padding-bottom: 4px;
    border-bottom: 2px solid var(--off-white-dk);
    box-sizing: border-box;
}

.shortcut-text {
    font-size: 13px;
    line-height: 17px;
}

.slash {
    color: var(--grey-dk);
    font-weight: 500;
    background-color: #f7f7fc;
    padding: 0 8px;
}

.recently-viewed-container {
    height: 100%;
    display: flex;
    align-items: space-between;
    flex-direction: column;
}

.recently-viewed {
    flex-grow: 1;
    overflow-y: auto;
}

/* Adds 16px of white-space to the bottom of the results for additional padding */
.recently-viewed::after,
.query-results::after {
    content: '';
    display: block;
    height: 16px;
    width: 100%;
}

.loading {
    font-size: 15px;
    color: var(--off-white-dk);
    text-align: center;
    padding-top: 32px;
}

.loading-icon {
    margin-top: 8px;
    fill: var(--off-white-dk);
}

.list-item-container {
    position: relative;
    display: flex;
    padding: 8px 16px;
    cursor: pointer;
}

.list-item-container:hover,
.list-item-container:focus {
    background-color: var(--off-white-dk);
}

.list-item-container--fake-focus {
    composes: list-item-container;
    background-color: var(--off-white-dk);
}

.list-item-more-link {
    composes: list-item-container;
    padding-left: 72px;
    font-size: var(--font-normal);
}

.list-item-more-link--fake-focus {
    composes: list-item-more-link;
    background-color: var(--off-white-dk);
}

.list-item-avatar {
    margin-right: 16px;
}

.list-item-content-container {
    font-size: var(--font-normal);
    color: var(--grey-dk);
    line-height: 19px;
    padding-right: 8px;
    overflow: hidden;
}

.secondary {
    color: var(--grey);
    overflow: hidden;
    text-overflow: ellipsis;
}

.name {
    font-weight: 500;
    color: var(--grey-dk);
    overflow: hidden;
    text-overflow: ellipsis;
}

.number {
    position: absolute;
    left: 0;
    font-size: 13px;
    top: 50px;
    width: 72px;
    text-align: center;
}

.primary-related {
    overflow: hidden;
    text-overflow: ellipsis;
}

.primary-related-company {
    composes: primary-related;
    color: var(--plum-dk);
}

.primary-related-person {
    composes: primary-related;
    color: var(--navy-dk);
}

.secondary-info {
    margin: -10px 16px 0 56px;
    padding-bottom: 12px;
    color: var(--grey);
    overflow: hidden;
    text-overflow: ellipsis;
}
